// MY CHRISTMAS — category allocation vs total budget (single source of truth). 5 langs.
export const extra13 = {
  pt: {
    "alloc.title": "⚠️ Você está aumentando seu orçamento",
    "alloc.human": "Você reservou {old} para {cat}, mas escolheu {new}. São {delta} a mais do que o planejado.",
    "alloc.free_used": "Você possui {free} de saldo livre.",
    "alloc.need": "Para manter seu orçamento total, precisamos redistribuir {v} de outras categorias.",
    "alloc.redistribute": "Redistribuir {v}", "alloc.exceed": "Continuar e ultrapassar o orçamento", "alloc.cancel": "Cancelar",
    "alloc.from_title": "De onde quer tirar {v}?", "alloc.available": "Disponível",
    "alloc.need_lbl": "Precisamos redistribuir", "alloc.selected": "Selecionado", "alloc.missing": "Falta",
    "alloc.suggest": "✨ Sugerir redistribuição", "alloc.confirm_redis": "Confirmar redistribuição",
    "alloc.exceed_title": "Confirmar alteração",
    "alloc.exceed_body": "Seu orçamento reservado para {cat} era {old}. Você está aumentando para {new}, ficando {delta} acima do planejado.",
    "alloc.aware": "Estou ciente e quero continuar", "alloc.back": "Voltar", "alloc.confirm": "Confirmar",
    "alloc.freed": "Você liberou {v} do seu orçamento.", "alloc.done": "Orçamento atualizado.",
    "alloc.set_total_first": "Defina primeiro o orçamento total do seu Natal em Meu Orçamento.",
  },
  en: {
    "alloc.title": "⚠️ You're increasing your budget",
    "alloc.human": "You reserved {old} for {cat}, but chose {new}. That's {delta} more than planned.",
    "alloc.free_used": "You have {free} of free balance.",
    "alloc.need": "To keep your total budget, we need to redistribute {v} from other categories.",
    "alloc.redistribute": "Redistribute {v}", "alloc.exceed": "Continue and go over budget", "alloc.cancel": "Cancel",
    "alloc.from_title": "Where should the {v} come from?", "alloc.available": "Available",
    "alloc.need_lbl": "We need to redistribute", "alloc.selected": "Selected", "alloc.missing": "Missing",
    "alloc.suggest": "✨ Suggest redistribution", "alloc.confirm_redis": "Confirm redistribution",
    "alloc.exceed_title": "Confirm change",
    "alloc.exceed_body": "Your reserved budget for {cat} was {old}. You're increasing it to {new}, {delta} over what you planned.",
    "alloc.aware": "I understand and want to continue", "alloc.back": "Back", "alloc.confirm": "Confirm",
    "alloc.freed": "You freed {v} from your budget.", "alloc.done": "Budget updated.",
    "alloc.set_total_first": "Set your total Christmas budget first in My Budget.",
  },
  es: {
    "alloc.title": "⚠️ Estás aumentando tu presupuesto",
    "alloc.human": "Reservaste {old} para {cat}, pero elegiste {new}. Son {delta} más de lo planeado.",
    "alloc.free_used": "Tienes {free} de saldo libre.",
    "alloc.need": "Para mantener tu presupuesto total, debemos redistribuir {v} de otras categorías.",
    "alloc.redistribute": "Redistribuir {v}", "alloc.exceed": "Continuar y superar el presupuesto", "alloc.cancel": "Cancelar",
    "alloc.from_title": "¿De dónde quieres sacar los {v}?", "alloc.available": "Disponible",
    "alloc.need_lbl": "Debemos redistribuir", "alloc.selected": "Seleccionado", "alloc.missing": "Falta",
    "alloc.suggest": "✨ Sugerir redistribución", "alloc.confirm_redis": "Confirmar redistribución",
    "alloc.exceed_title": "Confirmar cambio",
    "alloc.exceed_body": "Tu presupuesto reservado para {cat} era {old}. Lo aumentas a {new}, {delta} por encima de lo planeado.",
    "alloc.aware": "Lo entiendo y quiero continuar", "alloc.back": "Volver", "alloc.confirm": "Confirmar",
    "alloc.freed": "Liberaste {v} de tu presupuesto.", "alloc.done": "Presupuesto actualizado.",
    "alloc.set_total_first": "Define primero tu presupuesto total de Navidad en Mi Presupuesto.",
  },
  fr: {
    "alloc.title": "⚠️ Vous augmentez votre budget",
    "alloc.human": "Vous aviez réservé {old} pour {cat}, mais avez choisi {new}. C'est {delta} de plus que prévu.",
    "alloc.free_used": "Vous avez {free} de solde libre.",
    "alloc.need": "Pour garder votre budget total, nous devons redistribuer {v} depuis d'autres catégories.",
    "alloc.redistribute": "Redistribuer {v}", "alloc.exceed": "Continuer et dépasser le budget", "alloc.cancel": "Annuler",
    "alloc.from_title": "D'où prélever les {v} ?", "alloc.available": "Disponible",
    "alloc.need_lbl": "Nous devons redistribuer", "alloc.selected": "Sélectionné", "alloc.missing": "Manquant",
    "alloc.suggest": "✨ Proposer une redistribution", "alloc.confirm_redis": "Confirmer la redistribution",
    "alloc.exceed_title": "Confirmer le changement",
    "alloc.exceed_body": "Votre budget réservé pour {cat} était {old}. Vous l'augmentez à {new}, soit {delta} au-dessus du prévu.",
    "alloc.aware": "Je comprends et veux continuer", "alloc.back": "Retour", "alloc.confirm": "Confirmer",
    "alloc.freed": "Vous avez libéré {v} de votre budget.", "alloc.done": "Budget mis à jour.",
    "alloc.set_total_first": "Définissez d'abord votre budget total de Noël dans Mon Budget.",
  },
  it: {
    "alloc.title": "⚠️ Stai aumentando il tuo budget",
    "alloc.human": "Avevi riservato {old} per {cat}, ma hai scelto {new}. Sono {delta} in più del previsto.",
    "alloc.free_used": "Hai {free} di saldo libero.",
    "alloc.need": "Per mantenere il budget totale, dobbiamo ridistribuire {v} da altre categorie.",
    "alloc.redistribute": "Ridistribuire {v}", "alloc.exceed": "Continua e supera il budget", "alloc.cancel": "Annulla",
    "alloc.from_title": "Da dove prendere i {v}?", "alloc.available": "Disponibile",
    "alloc.need_lbl": "Dobbiamo ridistribuire", "alloc.selected": "Selezionato", "alloc.missing": "Mancante",
    "alloc.suggest": "✨ Suggerisci ridistribuzione", "alloc.confirm_redis": "Conferma ridistribuzione",
    "alloc.exceed_title": "Conferma modifica",
    "alloc.exceed_body": "Il budget riservato per {cat} era {old}. Lo aumenti a {new}, {delta} oltre il previsto.",
    "alloc.aware": "Ho capito e voglio continuare", "alloc.back": "Indietro", "alloc.confirm": "Conferma",
    "alloc.freed": "Hai liberato {v} dal tuo budget.", "alloc.done": "Budget aggiornato.",
    "alloc.set_total_first": "Imposta prima il budget totale del tuo Natale in Il mio Budget.",
  },
};
